import { environment } from '@candidate/environments/environment'
import Rollbar from 'rollbar'

const rollbarConfig: Rollbar.Configuration = {
  enabled: environment.env !== 'dev', // Don't emit when developing on local
  accessToken: '346f7aa091b0466381e715a7324927ea',
  captureUncaught: true,
  captureUnhandledRejections: true,
  recorder: {
    enabled: true,
    maskInputOptions: {
      password: true,
      email: true,
    },
  },
  payload: {
    environment: environment.env,
    server: {
      root: 'webpack:///./',
    },
    client: {
      javascript: {
        source_map_enabled: true, // true by default

        // The deploy's version step (replace.build.js) stamps this with the commit SHA the source maps
        // are uploaded under; Rollbar only un-minifies frames when the two match exactly.
        code_version: '609de00f08529568da8189c3312977b932a88b41',

        // Optionally have Rollbar guess which frames the error was
        // thrown from when the browser does not provide line
        // and column numbers.
        guess_uncaught_frames: true,
      },
    },
  },
}

export function rollbarFactory() {
  return new Rollbar(rollbarConfig)
}
